import { useState, useEffect, useCallback } from 'react';
import { useNavigate, useLocation, matchPath } from 'react-router-dom';
import useBlocker from './useBlocker';

export default function useNavigationPrompt(
  when: boolean,
  exceptions: any[] = []
) {
  const navigate = useNavigate();
  const location = useLocation();
  const [showPrompt, setShowPrompt] = useState(false);
  const [lastLocation, setLastLocation] = useState(null);
  const [confirmedNavigation, setConfirmedNavigation] = useState(false);

  const isExceptionPath = useCallback(
    (pathname) => {
      return exceptions.some((exception) => {
        const match = matchPath(exception, pathname);
        return match;
      });
    },
    [exceptions]
  );

  const cancelNavigation = useCallback(() => {
    setShowPrompt(false);
  }, []);

  const handleBlockedNavigation = useCallback(
    (nextLocation) => {
      if (isExceptionPath(nextLocation.location.pathname)) {
        setLastLocation(nextLocation);
        return true;
      }
      if (
        !confirmedNavigation &&
        nextLocation.location.pathname !== location.pathname
      ) {
        setShowPrompt(true);
        setLastLocation(nextLocation);
        return false;
      }
      return true;
    },
    [confirmedNavigation, isExceptionPath, location.pathname]
  );

  const confirmNavigation = useCallback(() => {
    setShowPrompt(false);
    setConfirmedNavigation(true);
  }, []);

  useEffect(() => {
    if (
      lastLocation &&
      (confirmedNavigation || isExceptionPath(lastLocation?.location.pathname))
    ) {
      navigate(lastLocation.location.pathname, {
        state: { ...lastLocation.location.state },
      });
    }
  }, [confirmedNavigation, isExceptionPath, lastLocation, navigate]);

  useBlocker(handleBlockedNavigation, when);

  return [showPrompt, confirmNavigation, cancelNavigation];
}
